
__webpack_require__.debugRequireIds = {
	"!!../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.106.2/node_modules/css-loader/dist/cjs.js!../../zulip-layer-loader.ts!./generated/emoji-styles/google-sprite.css": 26991,
	"!!../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.106.2/node_modules/css-loader/dist/cjs.js!../../zulip-layer-loader.ts!./generated/emoji-styles/twitter-sprite.css": 55389,
	"!style-loader?injectType=lazyStyleTag!css-loader!./generated/emoji-styles/google-sprite.css": 75007,
	"!style-loader?injectType=lazyStyleTag!css-loader!./generated/emoji-styles/twitter-sprite.css": 56077,
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 82901,
	"./generated/emoji/google.webp": 94213,
	"./generated/emoji/twitter.webp": 60889,
	"./src/base_page_params.ts": 88585,
	"./src/blueslip.ts": 67463,
	"./src/bot_types.ts": 20154,
	"./src/csrf.ts": 58315,
	"./src/i18n.ts": 8625,
	"./src/loading_error.ts": 61360,
	"./src/portico/google-analytics.ts": 50762,
	"./src/portico/portico_modals.ts": 60307,
	"./src/portico/tippyjs.ts": 88879,
	"./src/realm_user_settings_defaults.ts": 69757,
	"./src/retry_backoff.ts": 23128,
	"./src/state_data.ts": 39307,
	"./src/stream_types.ts": 12287,
	"./src/types.ts": 97620,
	"./src/user_settings.ts": 56748,
	"./src/user_status_types.ts": 86077,
	"./src/util.ts": 17369,
	"./third/bootstrap/css/bootstrap.portico.css": 69859,
	"altcha": 3187,
	"font-awesome/css/font-awesome.css": 23478,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 38417,
	"jquery": 63150,
	"jquery-validation": 9905,
	"lodash": 35558,
	"micromodal": 98476,
	"minimalistic-assert": 45185,
	"simplebar/dist/simplebar.css": 26990,
	"tippy.js": 99947,
	"tippy.js/dist/tippy.css": 35967
};